import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define a service using a base URL and expected endpoints
export const merchantAPI = createApi({
  reducerPath: "merchantAPI",
  baseQuery: fetchBaseQuery({
    baseUrl:
    "/th/KpaylaterConsoleDoc/",
      // "/SiteCollectionDocuments/personal/loan/personal-loan/paylater-map/json/",
  }),
  endpoints: (builder) => ({
    getMerchants: builder.query({
      query: () => "merchant.txt?limit=10",
      cacheTime: 60000,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetMerchantsQuery } = merchantAPI;
